export default "__VITE_ASSET__BuncBOym__"